import { useNavigate } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';
import { useClientQueries } from '@zenstackhq/tanstack-query/react';
import { schema } from '../__generated__/schema-lite';
import { useAuth } from '../auth/AuthContext';

/** Landing for authenticated-but-unapproved users. Everything except /me and
 *  logout is blocked at the policy layer; this page makes that explicit instead
 *  of showing a wall of 403 errors. */
export default function PendingApprovalPage() {
  const { setToken } = useAuth();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const crud = useClientQueries(schema);
  const { data: user } = crud.$procs.me.useQuery();

  return (
    <div className="mx-auto max-w-md px-4 py-12 sm:py-20 text-center space-y-4">
      <h1 className="text-2xl font-semibold">{t('pending.title')}</h1>
      <p className="text-muted-foreground">
        <Trans
          i18nKey="pending.body"
          values={{ email: (user?.email as string | undefined) ?? '' }}
          components={{ code: <code className="text-sm bg-muted px-1 rounded" /> }}
        />
      </p>
      <button
        type="button"
        onClick={() => {
          setToken(null);
          navigate('/login');
        }}
        className="btn-primary"
      >
        {t('action.signOut')}
      </button>
    </div>
  );
}
